module.exports = __webpack_public_path__ + "img/yanyidan.118ef36e.png";